import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    syncChannel = new Subject()
    repository = new IndexRepository()

    constructor() {
        this.syncChannel.next({status: apiResponse.INITIAL})
    }

    fetchSync = async (query) => {
        try {
            this.syncChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchSync(query).then((result) => {
                this.syncChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.syncChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {   }
    }
}

export default IndexBloc